import ScalarComboboxOptionGroup_vue_vue_type_script_setup_true_lang_default from "./ScalarComboboxOptionGroup.vue.script.js";
//#region src/components/ScalarCombobox/ScalarComboboxOptionGroup.vue
var ScalarComboboxOptionGroup_default = ScalarComboboxOptionGroup_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarComboboxOptionGroup_default as default };

//# sourceMappingURL=ScalarComboboxOptionGroup.vue.js.map